import {
  getGroupGochiMenusData,
  getGroupGochiMenuDetailData,
  addGroupGochiMenuData,
  editGroupGochiMenuData,
  deleteGroupGochiMenuData,
  addGroupGochiMenuImageData
} from '../libs/apis/GroupGochiMenuApi';

export const GET_GROUP_GOCHI_MENUS_REQUEST = 'GET_GROUP_GOCHI_MENUS_REQUEST';
export const GET_GROUP_GOCHI_MENUS_SUCCESS = 'GET_GROUP_GOCHI_MENUS_SUCCESS';
export const GET_GROUP_GOCHI_MENUS_FAILURE = 'GET_GROUP_GOCHI_MENUS_FAILURE';

export const GET_GROUP_GOCHI_MENU_DETAIL_REQUEST =
  'GET_GROUP_GOCHI_MENU_DETAIL_REQUEST';
export const GET_GROUP_GOCHI_MENU_DETAIL_SUCCESS =
  'GET_GROUP_GOCHI_MENU_DETAIL_SUCCESS';
export const GET_GROUP_GOCHI_MENU_DETAIL_FAILURE =
  'GET_GROUP_GOCHI_MENU_DETAIL_FAILURE';

export const ADD_GROUP_GOCHI_MENU_REQUEST = 'ADD_GROUP_GOCHI_MENU_REQUEST';
export const ADD_GROUP_GOCHI_MENU_SUCCESS = 'ADD_GROUP_GOCHI_MENU_SUCCESS';
export const ADD_GROUP_GOCHI_MENU_FAILURE = 'ADD_GROUP_GOCHI_MENU_FAILURE';

export const EDIT_GROUP_GOCHI_MENU_REQUEST = 'EDIT_GROUP_GOCHI_MENU_REQUEST';
export const EDIT_GROUP_GOCHI_MENU_SUCCESS = 'EDIT_GROUP_GOCHI_MENU_SUCCESS';
export const EDIT_GROUP_GOCHI_MENU_FAILURE = 'EDIT_GROUP_GOCHI_MENU_FAILURE';

export const DELETE_GROUP_GOCHI_MENU_REQUEST =
  'DELETE_GROUP_GOCHI_MENU_REQUEST';
export const DELETE_GROUP_GOCHI_MENU_SUCCESS =
  'DELETE_GROUP_GOCHI_MENU_SUCCESS';
export const DELETE_GROUP_GOCHI_MENU_FAILURE =
  'DELETE_GROUP_GOCHI_MENU_FAILURE';

export const ADD_GROUP_GOCHI_MENU_IMAGE_REQUEST =
  'ADD_GROUP_GOCHI_MENU_IMAGE_REQUEST';
export const ADD_GROUP_GOCHI_MENU_IMAGE_SUCCESS =
  'ADD_GROUP_GOCHI_MENU_IMAGE_SUCCESS';
export const ADD_GROUP_GOCHI_MENU_IMAGE_FAILURE =
  'ADD_GROUP_GOCHI_MENU_IMAGE_FAILURE';

export const getGroupGochiMenus = params => dispatch => {
  dispatch({ type: GET_GROUP_GOCHI_MENUS_REQUEST });
  return getGroupGochiMenusData(params)
    .then(response =>
      dispatch({
        type: GET_GROUP_GOCHI_MENUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_GOCHI_MENUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupGochiMenuDetail = groupMenuId => dispatch => {
  dispatch({ type: GET_GROUP_GOCHI_MENU_DETAIL_REQUEST });
  return getGroupGochiMenuDetailData(groupMenuId)
    .then(response =>
      dispatch({
        type: GET_GROUP_GOCHI_MENU_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_GOCHI_MENU_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGroupGochiMenu = params => dispatch => {
  dispatch({ type: ADD_GROUP_GOCHI_MENU_REQUEST });
  return addGroupGochiMenuData(params)
    .then(response =>
      dispatch({
        type: ADD_GROUP_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GROUP_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroupGochiMenu = (groupMenuId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_GOCHI_MENU_REQUEST });
  return editGroupGochiMenuData(groupMenuId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGroupGochiMenu = groupMenuId => dispatch => {
  dispatch({ type: DELETE_GROUP_GOCHI_MENU_REQUEST });
  return deleteGroupGochiMenuData(groupMenuId)
    .then(response =>
      dispatch({
        type: DELETE_GROUP_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_GROUP_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGroupGochiMenuImage = (groupMenuId, params) => dispatch => {
  dispatch({ type: ADD_GROUP_GOCHI_MENU_IMAGE_REQUEST });
  return addGroupGochiMenuImageData(groupMenuId, params)
    .then(response =>
      dispatch({
        type: ADD_GROUP_GOCHI_MENU_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GROUP_GOCHI_MENU_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
